import { nationCodeToName } from '@/constants/book';
import styled from 'styled-components';

const ChartTooltip = ({
  hasTotal = false,
  nations = [],
  active,
  payload,
  label,
  data,
}: any) => {
  if (data) {
    const { total, first, second, third, etc } = data;
    const [nation1, nation2, nation3] = nations;

    return (
      <StyledTooltip className='custom-tooltip'>
        {hasTotal && (
          <LeftSection>
            <DateLabel>{label}</DateLabel>
            {total}명
          </LeftSection>
        )}
        <RightSection hasTotal={hasTotal}>
          <Nation>
            <NationLabel color='#24C8FF'>
              {nationCodeToName(nation1).name}
            </NationLabel>
            <Data>{first}명</Data>
          </Nation>
          <Nation>
            <NationLabel color='#74CE30'>
              {nationCodeToName(nation2).name}
            </NationLabel>
            <Data>{second}명</Data>
          </Nation>
          <Nation>
            <NationLabel color='#FF8ED0'>
              {nationCodeToName(nation3).name}
            </NationLabel>
            <Data>{third}명</Data>
          </Nation>
          <Nation>
            <NationLabel color='#AF54FF'>기타</NationLabel>
            <Data>{etc}명</Data>
          </Nation>
        </RightSection>
      </StyledTooltip>
    );
  }

  return null;
};

const StyledTooltip = styled.div`
  display: flex;
  border-radius: 6px;
  border: 1px solid #d3e2fd;
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(52, 56, 97, 0.08);
  overflow: hidden;

  * {
    white-space: nowrap;
  }
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px;
  background-color: #f4f8ff;
  color: #5089f8;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

const DateLabel = styled.span`
  color: #246cf6;
  font-size: 10px;
  font-weight: 400;
  line-height: 15px;
`;

const RightSection = styled.dl<{ hasTotal: boolean }>`
  padding: 8px ${({ hasTotal }) => (hasTotal ? '8px' : '16px')} 8px
    ${({ hasTotal }) => (hasTotal ? '8px' : '12px')};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Nation = styled.div`
  display: flex;
  gap: 10px;
`;

const NationLabel = styled.dt<{ color: string }>`
  position: relative;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  color: ${({ color }) => color};
  padding-left: 10px;

  &::before {
    position: absolute;
    top: 2px;
    left: 0;
    content: '';
    width: 2px;
    height: 12px;
    background-color: ${({ color }) => color};
  }
`;

const Data = styled.dd`
  color: #80848a;
  font-size: 11px;
  font-weight: 400;
  line-height: 18px;
`;

export default ChartTooltip;
